define.alias("shared/components/shared/wistia-video", "calendar/components/shared/wistia-video");